import Vue from 'vue'

Vue.filter('profilePicture', (user, size = 'small') => {
  return (user.urls && user.urls[size]) || 'https://iconscout.com/_nuxt/img/87f97e0.svg'
})

Vue.filter('companyPicture', (user, size) => {
  return (user.company_urls && user.company_urls[size]) || 'https://iconscout.com/_nuxt/img/87f97e0.svg'
})

Vue.filter('coverPicture', (user, size) => {
  return (user.cover_urls && user.cover_urls[size]) || 'https://images.pexels.com/photos/323705/pexels-photo-323705.jpeg'
})
